import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowUpSquareContained = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M7.757 11.335 12 7.2m0 0 4.243 4.135M12 7.2v9.084m6 5.316H6A3.6 3.6 0 0 1 2.4 18V6A3.6 3.6 0 0 1 6 2.4h12A3.6 3.6 0 0 1 21.6 6v12a3.6 3.6 0 0 1-3.6 3.6"
    />
  </svg>
);
export default SvgArrowUpSquareContained;
